/*
  LNX infinite scroll for collection grids.

  Dawn paginates the grid server-side (?page=N). This script keeps that
  markup, hides the pagination visually and, as soon as the reader nears the
  end of the grid, fetches the next page via Section Rendering, appends its
  product cards and swaps in the fetched pagination so the chain continues.
  The URL is updated to the last loaded page. Dawn's facets replace the grid
  on filter/sort changes; a MutationObserver re-arms the loader afterwards.
*/
(function () {
  var container = document.getElementById('ProductGridContainer');
  if (!container || !container.hasAttribute('data-lnx-infinite')) return;

  var endText = container.getAttribute('data-lnx-infinite-end') || 'Alle Produkte geladen';
  var moreText = container.getAttribute('data-lnx-infinite-more') || 'Mehr laden';
  var loading = false;
  var observer = null;

  function grid() {
    return container.querySelector('#product-grid');
  }

  function statusEl(wrapper) {
    var status = container.querySelector('.lnx-infinite__status');
    if (!status) {
      status = document.createElement('div');
      status.className = 'lnx-infinite__status';
      status.setAttribute('aria-live', 'polite');
      wrapper.insertAdjacentElement('afterend', status);
    }
    return status;
  }

  function arm() {
    if (observer) observer.disconnect();
    var wrapper = container.querySelector('.pagination-wrapper');
    if (!wrapper) return;
    container.classList.add('lnx-infinite');
    var status = statusEl(wrapper);
    var next = wrapper.getAttribute('data-next-url');
    if (!next) {
      status.innerHTML = '<span class="lnx-infinite__end">' + endText + '</span>';
      return;
    }
    status.innerHTML = '<span class="lnx-infinite__spinner" role="status" aria-label="Lädt"></span>';
    observer = new IntersectionObserver(
      function (entries) {
        if (entries.some(function (e) { return e.isIntersecting; })) load(next, wrapper, status);
      },
      { rootMargin: '800px 0px' }
    );
    observer.observe(status);
  }

  function load(next, wrapper, status) {
    if (loading) return;
    loading = true;
    if (observer) observer.disconnect();
    status.classList.add('is-loading');

    var target = grid();
    var url = new URL(next, window.location.origin);
    url.searchParams.set('section_id', target.getAttribute('data-id'));

    fetch(url.toString())
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newGrid = doc.getElementById('product-grid');
        if (newGrid) {
          Array.prototype.slice.call(newGrid.children).forEach(function (li) {
            // Cards arrive after Dawn's scroll animations initialised; cancel them.
            if (li.classList.contains('scroll-trigger')) li.classList.add('scroll-trigger--cancel');
            li.querySelectorAll('.scroll-trigger').forEach(function (el) {
              el.classList.add('scroll-trigger--cancel');
            });
            target.appendChild(li);
          });
        }
        var newWrapper = doc.querySelector('.pagination-wrapper');
        if (newWrapper) {
          wrapper.replaceWith(newWrapper);
        } else {
          wrapper.removeAttribute('data-next-url');
        }
        var pageUrl = new URL(next, window.location.origin);
        pageUrl.searchParams.delete('section_id');
        if (window.history && window.history.replaceState) {
          window.history.replaceState(window.history.state, '', pageUrl.toString());
        }
        status.classList.remove('is-loading');
        loading = false;
        arm();
      })
      .catch(function () {
        // Fall back to a plain link so the reader can still get to the next page.
        status.classList.remove('is-loading');
        status.innerHTML = '<a class="lnx-infinite__link button" href="' + next + '">' + moreText + '</a>';
        loading = false;
      });
  }

  arm();

  // Facets (filters, sorting) replace the grid wholesale; re-arm on the new markup.
  new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var added = Array.prototype.slice.call(mutations[i].addedNodes);
      var hit = added.some(function (n) {
        return n.nodeType === 1 && (n.id === 'product-grid' || (n.querySelector && n.querySelector('#product-grid')));
      });
      if (hit) {
        loading = false;
        arm();
        break;
      }
    }
  }).observe(container, { childList: true });
})();
